
/* ======================================================
   SPACE AVAILABLE — NEWSLETTER
   JavaScript
   ====================================================== */

(() => {
  'use strict';

  const setupNewsletter = (root) => {

    if (!root) return;

    if (root.dataset.saNewsletterReady === 'true') {
      return;
    }

    root.dataset.saNewsletterReady = 'true';

    const form = root.querySelector(
      '.sa-newsletter__form'
    );

    const result = root.querySelector(
      '[data-sa-newsletter-result]'
    );

    /* ----------------------------------------------
       VERTICAL CENTERING / HEADER OFFSET
       ---------------------------------------------- */

    const updatePageOffset = () => {

      const wrapper =
        root.closest('.shopify-section') || root;

      const top =
        wrapper.getBoundingClientRect().top +
        window.scrollY;

      root.style.setProperty(
        '--sa-nl-top-offset',
        `${Math.max(0, Math.round(top))}px`
      );

    };

    updatePageOffset();

    window.addEventListener(
      'resize',
      updatePageOffset,
      { passive: true }
    );

    /* ----------------------------------------------
       FONT LOAD / LAYOUT ADJUSTMENT
       ---------------------------------------------- */

    if (document.fonts && document.fonts.ready) {

      document.fonts.ready
        .then(updatePageOffset)
        .catch(() => {});

    }

    /* ----------------------------------------------
       FORM SUBMISSION
       ---------------------------------------------- */

    if (form) {

      form.addEventListener('submit', () => {

        form.classList.add('is-submitting');

        form.setAttribute(
          'aria-busy',
          'true'
        );

      });

      /* RESET STATE AFTER PAGE NAVIGATION */

      window.addEventListener('pageshow', () => {

        form.classList.remove('is-submitting');

        form.removeAttribute('aria-busy');

      });

    }

    /* ----------------------------------------------
       SUCCESS / ERROR MESSAGE FOCUS
       ---------------------------------------------- */

    if (result) {

      result.focus({
        preventScroll: true
      });

    }

  };

  /* ----------------------------------------------
     INITIALIZATION
     ---------------------------------------------- */

  const init = (container = document) => {

    container
      .querySelectorAll('[data-sa-newsletter]')
      .forEach(setupNewsletter);

  };

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );

  } else {

    init();

  }

  /* ----------------------------------------------
     SHOPIFY THEME EDITOR SUPPORT
     ---------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      init(event.target);
    }
  );

})();
